import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Flex, Typography } from 'antd'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'
import CustomInput from 'src/app/shared/components/common/input'

const ACHForm: React.FC<any> = (props: any) => {
  const { control } = props;
  const { t } = useTranslation()
  return (
    <Flex vertical>
      <Typography.Text style={{ fontSize: '18px', fontWeight: '700', lineHeight: '28px', paddingBottom: '4px' }}>
        {t('AllTransactions:viewTransaction.ach.title')}
      </Typography.Text>

      <Flex vertical style={{ border: `1px solid ${colorBorderDisabled}`, padding: '16px', borderRadius: '16px' }}>
        <Flex style={{ gap: 24, marginBottom: "24px" }}>
          <Controller
            control={control}
            name='achOriginatorID'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.ach.originatorID')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
          <Controller
            control={control}
            name='transactionDescription'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.ach.description')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
        </Flex>
        <Flex style={{ gap: 24 }}>
          <Controller
            control={control}
            name='secCode'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.ach.sec_code')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
          <Controller
            control={control}
            name='drcr'
            render={({ field, fieldState }) => (
              <CustomInput
                label={t('AllTransactions:viewTransaction.ach.drcr')}
                value={field.value}
                onChange={field.onChange}
                error={fieldState.error}
                className='ant-input-view-only'
                disabled={true}
              />
            )}
          />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default ACHForm
